import React from 'react'
import Snackbar from '@mui/material/Snackbar'
import Alert from '@mui/material/Alert'

const FileTableSnackbars = ({
  refundSnackbarOpen,
  onRefundSnackbarClose,
  refundedFile,
  refundAmount,
  downloadFastqSnackbarOpen,
  onDownloadFastqSnackbarClose,
  downloadFastqFailedSnackbarOpen,
  onDownloadFastqFailedSnackbarClose,
  downloadBamFailedSnackbarOpen,
  onDownloadBamFailedSnackbarClose,
  paymentSnackbarOpen,
  onPaymentSnackbarClose,
  deductedAmount,
  newBalance,
}) => {
  return (
    <>
      <Snackbar
        open={refundSnackbarOpen}
        autoHideDuration={6000}
        onClose={onRefundSnackbarClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={onRefundSnackbarClose} severity="info" sx={{ width: '100%' }}>
          The annotation for file {refundedFile?.sample_name} failed. {refundAmount} has been refunded.
        </Alert>
      </Snackbar>

      <Snackbar
        open={downloadFastqSnackbarOpen}
        autoHideDuration={6000}
        onClose={onDownloadFastqSnackbarClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={onDownloadFastqSnackbarClose} severity="info" sx={{ width: '100%' }}>
          Your download will start shortly.
        </Alert>
      </Snackbar>

      <Snackbar
        open={downloadFastqFailedSnackbarOpen}
        autoHideDuration={6000}
        onClose={onDownloadFastqFailedSnackbarClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={onDownloadFastqFailedSnackbarClose} severity="error" sx={{ width: '100%' }}>
          Your download failed. Please try again. If the problem persists, please contact support.
        </Alert>
      </Snackbar>

      <Snackbar
        open={downloadBamFailedSnackbarOpen}
        autoHideDuration={6000}
        onClose={onDownloadBamFailedSnackbarClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={onDownloadBamFailedSnackbarClose} severity="error" sx={{ width: '100%' }}>
          BAM file download failed. Please try again. If the problem persists, please contact support.
        </Alert>
      </Snackbar>

      <Snackbar
        open={paymentSnackbarOpen}
        autoHideDuration={6000}
        onClose={onPaymentSnackbarClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={onPaymentSnackbarClose} severity="success" sx={{ width: '100%' }}>
          {deductedAmount} credits deducted. New balance: {newBalance}
        </Alert>
      </Snackbar>
    </>
  )
}

export default FileTableSnackbars
